import setInitialRender from '../actions/setInitialRender'

export default function initClientOnlyRequests(context) {
  setInitialRender(context)
}
